import Swiper from "swiper";
import { Autoplay, A11y, EffectFade, Pagination } from "swiper/modules";

function initSlideshows(): void {
  const slideshows: NodeListOf<Element> =
    document.querySelectorAll(".js-slideshow");

  slideshows.forEach((slideshow) => {
    if (slideshow instanceof HTMLElement) {
      const swiperAutoPlayOptions = slideshow.dataset.autoplayOptions
        ? JSON.parse(slideshow.dataset.autoplayOptions)
        : { autoplay: false };

      new Swiper(slideshow, {
        loop: true,
        modules: [Autoplay, A11y, EffectFade, Pagination],
        slidesPerView: 1,
        a11y: {
          enabled: true,
        },
        effect: "fade",
        fadeEffect: {
          crossFade: true,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        ...swiperAutoPlayOptions,
      });
    }
  });
}

/**
 * Initializes hero slideshow Swiper instances.
 * Uses readyState check to avoid the DOMContentLoaded race with async scripts.
 */
export function initializeHeroSlideshow(): void {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initSlideshows, {
      once: true,
    });
  } else {
    initSlideshows();
  }
}
